
































































































































































































































































































































































































import {
  CategoryCategoryDTO,
  CategoryListSubCategoryRequest,
  CategoryManagerService,
  CategorySubCategoryDTO,
  StoreManagementCreateItemRequest,
  StoreManagementEditItemRequest,
  StoreManagementSaleDTO,
  StoreManagementStoreService,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import EditOptionComponent from "@/components/admin/store/common/editOptionComponent.vue";
import EditSaleItemsComponent from "@/components/admin/store/common/editSaleItemsComponent.vue";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QEditor from "@/components/common/qEditor.vue";
import QInput from "@/components/common/qInput.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import QInputNumber from "@/components/common/qInputNumber.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSettingStore from "@/components/common/qReleaseSettingStore.vue";
import QSelect from "@/components/common/qSelect.vue";
import _ from "lodash";
import { error } from "logrocket";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const storeX = namespace("Store");

@Component({
  name: "StoreEditComponent",
  methods: { error },
  computed: {
    StoreManagementCreateItemRequest() {
      return StoreManagementCreateItemRequest;
    },
  },
  components: {
    QEditor,
    QLanguageTab,
    QInputNumber,
    QReleaseSettingStore,
    QErrors,
    QInputMultipleLanguage,
    QSelect,
    QInput,
    LanguageComponent,
    EditOptionComponent,
    EditSaleItemsComponent,
  },
})
export default class StoreEditComponent extends Vue {

  get contextLangList() {
    const langEn = this.languages.en;
    const langCn = this.languages.cn;

    return [...[LANG.JA], ...(langEn ? ["en"] : []), ...(langCn ? ["cn"] : [])];
  }

  get contentLanguageComputed() {
    if (this.languages[this.contentLanguage] === true) {
      return this.contentLanguage;
    } else {
      return "ja";
    }
  }
  public title = "飼育資材ストアの新規作成";
  public errors = {};
  public languages = {
    ja: true,
    en: true,
    cn: false,
  };
  public startDate = null;
  public endDate = null;

  public categories: CategoryCategoryDTO[] = [];
  public subCategories: CategorySubCategoryDTO[] = [];
  public sales: StoreManagementSaleDTO[] = [];

  public item = {
    id: null,
    categoryId: null,
    subCategoryId: null,
    code: null,
    type: StoreManagementCreateItemRequest.type.BOTH,
    language: StoreManagementCreateItemRequest.language.ALL,
    name: null,
    nameEn: null,
    nameCn: null,
    optionNames: [],
    optionNamesEn: [],
    optionNamesCn: [],
    company: null,
    companyEn: null,
    companyCn: null,
    isPrice: false,
    price: null,
    salePrice: null,
    isQuantity: false,
    quantity: null,
    context: "",
    contextEn: null,
    contextCn: null,
    openStatus: StoreManagementCreateItemRequest.openStatus.HOLD,
    releaseSetting: null,
    postDate: null,
    saleId: null,
    images: [],
    saleCode: null,
    startDate: null,
    endDate: null,
    categoryName: null,
    subCategoryName: null,
  };

  public origin;

  public isEditing = false;

  public isLoadingSubCategories = false;

  public isRequiredSubCategory = false;

  public contentLanguage = "ja";

  @storeX.Action
  public updateItem!: (live) => void;

  public async mounted() {
    const id = Number(this.$router.currentRoute.params.id);
    if (!id) {
      this.origin = _.cloneDeep(this.item);
    }
  }

  public created() {
    this.getCategories();

    const id = Number(this.$router.currentRoute.params.id);
    if (id) {
      this.isEditing = true;
      this.getDetail(id).then(() => {
        this.getSubCategories();
      });
    }

    this.getSales();
  }

  public async getDetail(id) {
    try {
      const { data } = await StoreManagementStoreService.adminStoreView({
        id,
      });

      this.item = {
        id: data.item.id,
        categoryId: data.item.category_id,
        subCategoryId: data.item.sub_category_id,
        code: data.item.code,
        type: data.item.type as StoreManagementCreateItemRequest.type,
        language: data.item
          .language as StoreManagementCreateItemRequest.language,
        name: data.item.name,
        nameEn: data.item.name_en,
        nameCn: data.item.name_cn,
        optionNames: data.item.option_names
          ? data.item.option_names.split("|")
          : null,
        optionNamesEn: data.item.option_names_en
          ? data.item.option_names_en.split("|")
          : null,
        optionNamesCn: data.item.option_names_cn
          ? data.item.option_names_cn.split("|")
          : null,
        company: data.item.company,
        companyEn: data.item.company_en,
        companyCn: data.item.company_cn,
        isPrice: data.item.is_price,
        price: data.item.price,
        salePrice: data.item.sale_price,
        isQuantity: data.item.is_quantity,
        quantity: data.item.quantity,
        context: data.item.context,
        contextEn: data.item.context_en,
        contextCn: data.item.context_cn,
        openStatus: data.item
          .open_status as StoreManagementCreateItemRequest.openStatus,
        releaseSetting: data.item.release_setting,
        postDate: data.item.post_date,
        saleId: data.item.sale_id,
        images: data.item.images,
        saleCode: null,
        startDate: null,
        endDate: null,
        categoryName: null,
        subCategoryName: null,
      };

      this.title = data.item.name + "の編集";
      this.origin = _.cloneDeep(this.item);
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });

      await this.$router.push({ name: "notFound" });
    }
  }

  public async getCategories() {
    const result = await CategoryManagerService.adminCategory({});
    this.categories = result.data.categories;
  }

  public async getSales() {
    const result = await StoreManagementStoreService.adminStoreListSale({});
    this.sales = result.data.sales;
  }

  public changeCategory() {
    this.item.subCategoryId = null;
    this.subCategories = [];
    this.getSubCategories();
  }

  public changeSubCategory() {
    if (this.item.subCategoryId == "null") {
      this.item.subCategoryId = null;
    }
  }

  public validateQuantity() {
    const result = this.item.quantity.replace(/\D/g, "");
    this.item.quantity = result;
  }

  public changeQuantity() {
    if (!this.item.isQuantity) {
      this.item.quantity = null;
    }
  }

  public async getSubCategories() {
    if (this.item.categoryId) {
      this.isLoadingSubCategories = true;
      const result = await CategoryManagerService.adminSubCategory({
        categories: [this.item.categoryId],
        disabledLoadinng: true,
      } as CategoryListSubCategoryRequest);
      this.subCategories = result.data.sub_categories;
      this.isRequiredSubCategory = this.subCategories.length > 0;
      this.isLoadingSubCategories = false;
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      onConfirm: () => {
        this.delete();
      },
      onClose: () => {
        //
      },
    });
  }

  public confirmCancel() {
    if (_.isEqual(this.item, this.origin)) {
      this.$router.back();
    } else {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.back();
        },
        onClose: () => {
          //
        },
      });
    }
  }

  public async submit() {
    this.errors = {};
    let result;

    try {
      if (!this.isEditing) {
        result = await StoreManagementStoreService.adminStoreCreate(
          this.item as StoreManagementCreateItemRequest,
        );
      } else {
        result = await StoreManagementStoreService.adminStoreEdit(
          this.item as StoreManagementEditItemRequest,
        );
      }

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
        if ("context" in this.errors) {
          this.contentLanguage = LANG.JA;
        } else if ("contextEn" in this.errors) {
          this.contentLanguage = LANG.EN;
        } else if ("contextCn" in this.errors) {
          this.contentLanguage = LANG.CN;
        }
      }
    }
  }

  public async delete() {
    this.errors = {};

    try {
      const result = await StoreManagementStoreService.adminStoreDelete({
        id: this.item.id,
      });

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      const result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public preview() {
    this.item.categoryName = this.categories.find(
      (category) => category.id == this.item.categoryId,
    ).name;
    this.item.subCategoryName = this.subCategories.find(
      (subCategory) => subCategory.id == this.item.subCategoryId,
    ).name;
    this.updateItem(_.cloneDeep(this.item));
    window.open("/store/preview", "_blank");
  }

  public capitalizeLang(lang) {
    return _.capitalize(lang);
  }
}
